module.exports = __webpack_public_path__ + "f26212c254a021d9eccea53843dffbc1.fbx";